import { RestoreLockBanner } from './RestoreLockBanner';
import { SfeVersionBanner } from './SfeVersionBanner';

/** The SFE notices of every screen: the version's attestation state, then the restore lock. */
export function SfeNotices() {
  return (
    <>
      <SfeVersionBanner />
      <RestoreLockBanner />
    </>
  );
}
